import gsap from "gsap";

window.addEventListener("load", () => {

  // ★ bodyに p-top がなければ何もしない
  if (!document.body.classList.contains("p-top")) return;

  const body = document.body;
  const header = document.querySelector("header");
  const mark = document.querySelector(".mark");
  const logo = document.querySelector(".logo");
  const logoMask = document.querySelector(".logo-mask");
  const inner = document.querySelector(".mv-sec .inner");
  const title = document.querySelector(".title");

  const fadeDistance = 300;
  const firstVisit = !sessionStorage.getItem("mvPlayed");

  let logoWidth = logoMask.getBoundingClientRect().width;
  const updateLogoWidth = () => {
    logoWidth = logoMask.getBoundingClientRect().width;
  };
  window.addEventListener("resize", updateLogoWidth);

  // 初期セット
  gsap.set(mark, { scale: 0, rotation: 90, transformOrigin: "50% 50%" });
  gsap.set(logo, { width: 0, overflow: "hidden" });
  gsap.set(header, { opacity: 0 });
  gsap.set(inner, { opacity: 1 });
  gsap.set(title, { opacity: 0 });

  if (firstVisit) {
    sessionStorage.setItem("mvPlayed", "true");
    body.style.overflow = "hidden";

    gsap.timeline({
      onComplete: () => {
        body.style.overflow = "";
        gsap.to(header, { opacity: 1, duration: 0.8, ease: "power2.out" });
      }
    })
      .to(title, { opacity: 1, duration: 0.3, ease: "power2.out" })
      .to(mark, { scale: 1, duration: 0.3, ease: "back.out(2.8)" })
      .to(mark, { rotation: 0, duration: 0.2, ease: "power3.inOut" }, "+=1")
      .to(logo, { width: () => logoWidth, duration: 0.6, ease: "power3.inOut" }, "+=0.2");

  } else {
    gsap.set(mark, { scale: 1, rotation: 0, transformOrigin: "50% 50%" });
    gsap.set(logo, { width: logoWidth });
    gsap.set(header, { opacity: 1 });
    gsap.to(title, {
      opacity: 1,
      duration: 0.3,
      ease: "power2.out"
    });
  }

  const fadeByScroll = () => {
    const scrollY = window.scrollY;
    const progress = Math.min(scrollY / fadeDistance, 1);
    inner.style.opacity = 1 - progress;
  };

  window.addEventListener("scroll", fadeByScroll);
  window.addEventListener("resize", fadeByScroll);
  fadeByScroll();
});
